import { makeStyles } from "@material-ui/core/styles";

const style = makeStyles((theme) => ({
  margin: {
    margin: "48px 120px",
  },
  homeBannerCard: {
    width: "100%",
  },
  "@media (min-width: 651px) and (max-width: 850px)": {
    homeBanner:{
        width:"90%",
        padding:"0px 0px 24px 60px"
      }
  },
  "@media (min-width: 551px) and (max-width: 650px)": {
    homeBanner:{
      width:"90%",
      padding:"0px 0px 24px 60px"
    }
  },
  "@media (max-width: 550px)": {
    homeBannerCard: {
      maxWidth: "550px",
    },
    homeBanner: {
      cursor: "pointer",
      width: "100%",
      display: "block",
      padding: "0px 16px 12px 16px",
    },
  },
}));

export default style;
